import { createGlobalStyle } from 'styled-components'

// VARIABLES //

export const colorPitch = '#000'
export const colorBlack = '#252A36'
export const colorYellow = '#FEF154'
export const colorWhite = '#fff'
export const colorRed = '#e95e5e'
export const colorOrange = '#f5a623'

// CONSTANTS //

export const stations = { 'stockholm': 'sto', 'arlandaSouth': 'arn-s', 'arlandaNorth': 'arn-n' }

// GLOBAL STYLES //
export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: NotoSans;
    src: local('Noto Sans Regular'),local('NotoSans-Regular'),
      url('/fonts/NotoSans-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: NotoSans;
    font-weight: bold;
    src: local('Noto Sans Bold'),local('NotoSans-Bold'),
      url('/fonts/NotoSans-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: TransferSans;
    src: local('Transfer Sans'),local('TransferSans-Regular'),
      url('/fonts/TransferSans.otf') format('opentype');
  }

  *, *:before, *:after {
    box-sizing: border-box;
  }


  body {
    margin: 0;
    background: ${colorPitch};
    color: ${colorWhite};
    font-size: 16px;
    font-family: NotoSans, 'Noto Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
    height: 100vh;
    width: 100vw;
  }
`
